const inferWindowOrigin = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.location.origin;
};

// W DEV preferujemy proxy CRA (frontend/package.json: "proxy": "http://localhost:3021")
// aby uniknąć CORS – wtedy używamy ścieżki względnej '/api'.
const useDevProxy = process.env.NODE_ENV === 'development' && !process.env.REACT_APP_API_URL;

let API_ORIGIN = '';
let API_BASE_URL = '';

if (useDevProxy) {
  API_ORIGIN = '';
  API_BASE_URL = '/api';
} else {
  const FALLBACK_ORIGIN = process.env.NODE_ENV === 'development'
    ? 'http://localhost:3021'
    : 'https://zadania.app';

  const inferred = inferWindowOrigin();
  const rawOrigin = (process.env.REACT_APP_API_URL || inferred || FALLBACK_ORIGIN).replace(/\/$/, '');
  API_ORIGIN = rawOrigin;
  API_BASE_URL = `${API_ORIGIN}/api`;
}

export { API_ORIGIN, API_BASE_URL };

const inferWindowSocketBase = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const { protocol, host } = window.location;
  const wsProtocol = protocol === 'https:' ? 'wss:' : 'ws:';
  return `${wsProtocol}//${host}`;
};

const SOCKET_FALLBACK = (API_ORIGIN || inferWindowOrigin() || 'http://localhost:3021').replace(/^http/, 'ws');

export const getSocketBase = (): string => inferWindowSocketBase() || SOCKET_FALLBACK;

export const buildSocketUrl = (path = '/socket.io/'): string => {
  const normalisedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getSocketBase()}${normalisedPath}`;
};

export const buildApiUrl = (path: string): string => {
  const normalisedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalisedPath}`;
};
